/* Unik — colourway + in-stock filtering over the rendered card grid.
   Client-side so the segmented control stays instant; every card
   carries data-colourway and data-instock from Liquid. */
(function () {
  function apply(scope) {
    var colour = scope.querySelector('[data-colourway-filter] input:checked');
    var want = colour ? colour.value : 'all';
    var stockOnly = scope.querySelector('[data-instock-filter]');
    var onlyInStock = stockOnly ? stockOnly.checked : false;

    var shown = 0;
    scope.querySelectorAll('[data-product-card]').forEach(function (card) {
      var okColour = want === 'all' || card.dataset.colourway === want;
      var okStock = !onlyInStock || card.dataset.instock === 'true';
      var visible = okColour && okStock;
      card.hidden = !visible;
      if (visible) shown += 1;
    });

    var count = scope.querySelector('[data-result-count]');
    if (count) {
      var one = count.dataset.one || 'style';
      var many = count.dataset.many || 'styles';
      count.textContent = shown + ' ' + (shown === 1 ? one : many);
    }

    var empty = scope.querySelector('[data-empty]');
    if (empty) empty.hidden = shown !== 0;
  }

  document.addEventListener('change', function (e) {
    var scope = e.target.closest('[data-filter-scope]');
    if (!scope) return;
    if (e.target.closest('[data-colourway-filter]') || e.target.closest('[data-instock-filter]')) {
      apply(scope);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-filter-scope]').forEach(apply);
  });
})();
